import { useCurrentSplitLevelQuery } from 'src/hooks/split-levels';
import { SalesBudgetInheritanceLevelEnum } from 'src/infrastructure/rest-api/api-types';

export const useTurnoverSplitLevel = (): SalesBudgetInheritanceLevelEnum | null => {
    const { data } = useCurrentSplitLevelQuery();
    const splitLevel = data?.salesBudget?.salesBudgetSplit;
    return splitLevel ?? null;
};
